import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from '../../components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from '../../icons/icons.module';
import { TableModule } from 'src/app/table/table.module';
import { LeftSideNavigationModule } from 'src/app/layout/left-side-navigation/left-side-navigation.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {WorkflowDiagramModule} from 'src/app/components/workflow-diagram/workflow-diagram.module';
import {AuditMgmtRoutingModule} from './audit-mgmt-routing.module';
import {SearchFilterModule} from 'src/app/components/search-filter/search-filter.module';
import {AuditMgmtComponent} from './audit-mgmt.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DefaultFilterModule} from '../../components/default-filter/default-filter.module';
import {MatMenuModule} from '@angular/material/menu';
import {InstanceDetailsModule} from 'src/app/components/instance-details/instance-details.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AuditFilterComponent } from '../audit-filter/audit-filter.component';

@NgModule({
  declarations: [
    AuditMgmtComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    AuditMgmtRoutingModule,
    IconsModule,
    TableModule,
    LeftSideNavigationModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    ToolbarModule,
    PaginatorModule,
    WorkflowDiagramModule,
    SearchFilterModule,
    MatProgressBarModule,
    MatTooltipModule,
    DefaultFilterModule,
    MatMenuModule,
    InstanceDetailsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatButtonModule,
    AuditFilterComponent
  ]
})
export class AuditMgmtListModule { }
